module.exports = __webpack_public_path__ + "img/logo-footer.bda94bf7.svg";